import React, { CSSProperties, FC, useMemo } from 'react';
import classNames from 'classnames';
import classes from './styles/elevation.module.scss';
import { white } from '../Color';

type ElevationProps = {
	children?: React.ReactNode;
	className?: string;
	borderRadius?: string;
	backgroundColor?: string;
	boxShadow?: 'none' | 'tiny' | 'small' | 'medium' | 'large' | 'extraLarge';
	onClick?: () => void;
	style?: CSSProperties;
	dataTestId?: string;
};

export const Elevation: FC<React.PropsWithChildren<ElevationProps>> = ({
	children,
	className,
	boxShadow = 'tiny',
	borderRadius,
	backgroundColor = white,
	onClick,
	style,
	dataTestId,
}) => {
	const componentStyle = useMemo(
		() => ({
			borderRadius,
			backgroundColor,
			...style,
		}),
		[backgroundColor, borderRadius, style],
	);

	const componentClasses = classNames(
		classes.elevation,
		{
			[classes[`elevation_boxShadow-${boxShadow}`]]: typeof boxShadow !== 'undefined' && boxShadow !== 'none',
		},
		className,
	);

	return (
		<div
			style={componentStyle}
			className={componentClasses}
			onClick={onClick}
			data-testid={dataTestId}
		>
			{children}
		</div>
	);
};
